export default (that) => [
  {
    text: that.$l('menu_text_detail') || '查看详情',
    icon: 'el-icon-view',
    menuType: 'detail',
  },
  {
    text: that.$l('menu_text_edit') || '编辑单据',
    icon: 'el-icon-edit',
    menuType: 'edit',
    divided: true,
    allow: 'M',
    disabled: ({ amzFirstDemandStatus }) => {
      return ['D', 'Y', 'T'].includes(amzFirstDemandStatus)
    },
  },
  {
    text: that.$l('menu_text_delete') || '删除单据',
    icon: 'el-icon-delete',
    menuType: 'delete',
    divided: false,
    allow: 'D',
    disabled: ({ amzFirstDemandStatus }) => {
      return !['N', 'B'].includes(amzFirstDemandStatus)
    },
  },
    {
    text: that.$l('menu_text_submit_review') || '提交审核',
    icon: 'el-icon-check',
    menuType: 'submitReview',
    divided: true,
    allow: 'SR',
    disabled: ({ amzFirstDemandStatus }) => {
      return !['N', 'B'].includes(amzFirstDemandStatus)
    },
  },
  // {
  //   text: that.$l('menu_text_submit_operate') || '提交运营确认',
  //   icon: 'el-icon-document-checked',
  //   menuType: 'submit',
  //   divided: true,
  //   allow: 'S',
  //   disabled: ({ amzFirstDemandStatus }) => {
  //     return !['N', 'R'].includes(amzFirstDemandStatus)
  //   },
  // },
  // {
  //   text: that.$l('menu_text_submit_design') || '提交企划确认',
  //   icon: 'el-icon-success',
  //   menuType: 'submitPlan',
  //   divided: false,
  //   allow: 'R',
  //   disabled: ({ amzFirstDemandStatus }) => {
  //     return !['S'].includes(amzFirstDemandStatus)
  //   },
  // },
  // {
  //   text: that.$l('menu_text_submit_procurement') || '提交采购',
  //   icon: 'el-icon-check',
  //   menuType: 'submitProcurement',
  //   divided: true,
  //   allow: 'Y',
  //   disabled: ({ amzFirstDemandStatus }) => {
  //     return !['R'].includes(amzFirstDemandStatus)
  //   },
  // },
  // {
  //   text: that.$l('menu_text_cancelPurchase') || '取消采购',
  //   icon: 'el-icon-sold-out',
  //   menuType: 'cancel-purchase',
  //   allow: 'B',
  //   disabled: ({ amzFirstDemandStatus }) => amzFirstDemandStatus !== 'Y',
  // },
]
